import React from "react";

import {
  formatCurrency,
} from "../utils/publicOffer.utils";


const PublicOfferTotals = ({
  publicOffer,
}) => {

  const offer =
    publicOffer?.offer;

  if (!offer) {
    return null;
  }


  const currency =
    offer.currency || "INR";


  return (
    <section className="public-offer-totals">

      <div className="public-offer-total-row">

        <span>
          Subtotal
        </span>

        <strong>
          {formatCurrency(
            offer.subtotal,
            currency
          )}
        </strong>

      </div>


      <div className="public-offer-total-row discount">

        <span>
          Discount
        </span>

        <strong>
          -{" "}
          {formatCurrency(
            offer.discountAmount,
            currency
          )}
        </strong>

      </div>


      <div className="public-offer-total-row">

        <span>
          Tax
        </span>

        <strong>
          {formatCurrency(
            offer.taxAmount,
            currency
          )}
        </strong>

      </div>


      <div className="public-offer-total-row grand-total">

        <span>
          Total
        </span>

        <strong>
          {formatCurrency(
            offer.totalAmount,
            currency
          )}
        </strong>

      </div>

    </section>
  );
};


export default PublicOfferTotals;
